/** Seeded default company. Used when no company is selected yet. */
export const DEFAULT_ACCOUNTING_COMPANY_ID = 'E0000001-0001-4001-8001-000000000001';

export const ACCOUNTING_COMPANY_SESSION_KEY = 'accounting.activeCompanyId';

/** Sent on accounting API calls so the backend resolves CurrentCompanyId. */
export const ACCOUNTING_COMPANY_HTTP_HEADER = 'X-Accounting-Company-Id';

/** FRD alias — accepted by CompanyContextMiddleware when the accounting header is not sent. */
export const FRD_COMPANY_HTTP_HEADER = 'X-Company-Id';

/** True when user has opened a company (gateway / transactions). */
export const ACCOUNTING_COMPANY_OPEN_SESSION_KEY = 'accounting.companyOpen';

export const ACCOUNTING_CURRENCY_SYMBOL = '₹';
export const ACCOUNTING_CURRENCY_FORMAL_NAME = 'INR';

/** GSTVerify auto-fill on company master — set true when ready to enable. */
export const COMPANY_GST_AUTO_VERIFY_ENABLED = false;
